import { render, staticRenderFns } from "./2ActivityManagement.vue?vue&type=template&id=ca414914&scoped=true&"
import script from "./2ActivityManagement.vue?vue&type=script&lang=js&"
export * from "./2ActivityManagement.vue?vue&type=script&lang=js&"
import style0 from "./2ActivityManagement.vue?vue&type=style&index=0&id=ca414914&scoped=true&lang=css&"
import style1 from "./2ActivityManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca414914",
  null
  
)

export default component.exports